import navigation from "@/pages/global/components/nav-bar/nav-bar.vue";
import bottom from "@/pages/global/components/bottom-bar/bottom-bar.vue";

export default {
    mounted() {
        let externalScript = document.createElement('script')
        externalScript.setAttribute('src', '/static/assets/js/pages/custom/login/login-general.js?v=7.0.6')
        document.head.appendChild(externalScript)
    },
    components: {
        navigation,
        bottom
    },
    computed: {
        emailLogin: {
            get() {
                return this.$store.state.login.formLogin.email;
            },
            set(value) {
                this.$store.commit("login/setFormLoginInput", {
                    fieldToEdit: 'email',
                    fieldToEditValue: value,
                });
            }
        },
        passwordLogin: {
            get() {
                return this.$store.state.login.formLogin.password;
            },
            set(value) {
                this.$store.commit("login/setFormLoginInput", {
                    fieldToEdit: 'password',
                    fieldToEditValue: value,
                });
            }
        },
        emailRegister: {
            get() {
                return this.$store.state.login.formRegister.email;
            },
            set(value) {
                this.$store.commit("login/setFormRegisterInput", {
                    fieldToEdit: 'email',
                    fieldToEditValue: value,
                });
            }
        },
        passwordRegister: {
            get() {
                return this.$store.state.login.formRegister.password;
            },
            set(value) {
                this.$store.commit("login/setFormRegisterInput", {
                    fieldToEdit: 'password',
                    fieldToEditValue: value,
                });
            }
        },
        passwordRegisterConfirm: {
            get() {
                return this.$store.state.login.formRegister.passwordConfirm;
            },
            set(value) {
                this.$store.commit("login/setFormRegisterInput", {
                    fieldToEdit: 'passwordConfirm',
                    fieldToEditValue: value,
                });
            }
        },
        agreeRegisterConfirm: {
            get() {
                return this.$store.state.login.formRegister.agree;
            },
            set(value) {
                this.$store.commit("login/setFormRegisterInput", {
                    fieldToEdit: 'agree',
                    fieldToEditValue: value,
                });
            }
        },
        emailForgotPassword: {
            get() {
                return this.$store.state.login.formForgot.email;
            },
            set(value) {
                this.$store.commit("login/setFormForgotEmail", {
                    fieldToEdit: 'email',
                    fieldToEditValue: value,
                });
            }
        }
    },
    methods: {

        submitLogin(evt) {
            evt.preventDefault();
            this.$store.dispatch('login/submitLogin');
        },

        submitRegister(evt) {
            evt.preventDefault();
            this.$store.dispatch('login/submitRegister');
        },

        submitForgotPassword(evt) {
            evt.preventDefault();
            this.$store.dispatch('login/submitForgotPassword');
        },

        signInWithGoogle() {
            this.$store.dispatch('login/signInWithGoogle');
        },

        signInWithApple() {
            this.$store.dispatch('login/signInWithApple');
        }

    }
};


// WEBPACK FOOTER //
// ./src/pages/login/master/login.js